import React from "react"
import { useCallback, useMemo } from "react"
import { Avatar } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "providers/i18n"
import { CustomIcon } from "components/icons"
import get from "lodash/get"
import { getFeatureDetail } from "utils/feature"
import _ from "lodash"

import { FeatureListItem } from "components/domains/features"
import { ShopIcon } from "../../icons"
import { useVenue } from "providers/venue"

export const ShopListItem = ({ occupant, hideLevel = false }) => {
  const { t } = useTranslation({ defaultValue: null })
  const { isMultiVenueProject } = useVenue()
  const navigate = useNavigate()
  const { name, logo, level, group, zone, venueLogo } = useMemo(
    () => getFeatureDetail(occupant),
    [occupant]
  )
  const handleClick = useCallback(
    () => navigate(`/maps/place/${occupant.id}`),
    [navigate, occupant?.id]
  )

  const zoneText = useMemo(() => t(zone), [t, zone])

  const categoryIcon = useMemo(
    () => get(occupant, "properties.local_categories[0].properties.icon_path"),
    [occupant]
  )
  const groupText = useMemo(() => t(group), [t, group])

  return (
    <FeatureListItem
      divider
      onClick={handleClick}
      primary={t(name)}
      secondary={_.compact([
        !hideLevel && level && `${level} Floor `,
        !hideLevel && level && zoneText && "| ",
        zoneText && `${t("Zone")} ${zoneText} `,
        group && groupText,
      ])}
      avatar={
        <Avatar src={logo} variant="logo">
          {!logo &&
            (categoryIcon ? <CustomIcon path={categoryIcon} /> : <ShopIcon />)}
        </Avatar>
      }
      endAdornment={isMultiVenueProject && venueLogo}
    />
  )
}

export default ShopListItem
